export const NAV_BAR_ID = 'app-navigation-bar';
export const NAV_BAR_CONTENT_ID = 'app-navigation-bar-content';
export const PARTNER_BANNER_HEIGHT = 55;
export const STUDIO_BANNER_ID = 'studioBannerContain';
export const MONARCH_HEADER_ID = 'monarch-header-id';
export const PARTNER_BANNER_ID = 'partner-banner-id';
